import { IconName } from "assets/icons/UnumSync";
import { metaInformation } from "../metaInformation";
import { navLink } from "./navLink";

export type navDraw = {
  id: string;
  depth?: number;
  icon?: IconName;
  label: string;
  items: (navLink | navDraw)[];
} & metaInformation<"draw">;

export function isNavDraw(item: any): item is navDraw {
  return item?.type === "draw";
}
